<template>
    <div>
        <div>
            <el-carousel indicator-position="outside" height="280px" arrow="always">
                <el-carousel-item>
					<img  style="height: 280px;" src="../images/lb1.png">
                </el-carousel-item>
            </el-carousel>
        </div>
        <div style="width: 111px;height: 111px; position: fixed;  left: 90%; top:530px; cursor: pointer; "
			@click="aiChatShow = !aiChatShow">
			<img src="../images/ailogo.png" />
			<div style="font-size: 15px;color: #000000; position: relative; bottom: 30px;left: 31px;">AI助理</div>
		</div>
		<div class="chat-dialog" style="width: 494px;height: 328px; border: none; z-index: 100;" v-show="aiChatShow">
			<div style="height: 21px; float: right;">
				<!-- <div style="height: 21px;width: 21px; margin-right: 10px;margin-top: 10px; cursor: pointer;"
					@click="toAiChat()"><img src="../images/qp.png" /></div> -->
			</div>
			<div class="chat-content" ref="chatContainer" style="margin-top: 20px;">
				<div v-for="(message, index) in messages" :key="index">
					<div style="display: flex; margin-top: 10px; " v-if="message.type == 'bot'">
						<div style="width: 36px; height: 36px;margin-left: 7px; "><img src="../images/boticon.png" />
						</div>
						<div
							style="max-width: 85%;background: linear-gradient(-30deg, #A2DAED 0%, #B3D2F7 100%);  padding-bottom: 10px;border-radius: 9px;">
							<div style=" white-space : pre-wrap; max-width: 85%; color: #333333; border-radius: 9px; padding: 7px;margin-left: 5px;display: flex;align-items: center;"
								>{{ message.text }}
							</div>
							<div style=" max-width: 85%; background: #FFFFFF;opacity: 0.4;   width: fit-content;
border-radius: 3px 3px 3px 3px;
 font-size: 10px;height: 21px;border-radius: 3px 3px 3px 3px; color: #1F6EE4;margin-left: 12px; margin-top: 3px;display: flex; align-items: center;justify-content: center;padding-left: 10px; padding-right: 10px; cursor: pointer;"
								v-for="(item, index) in message.fllowups" @click="sendMessageByFllowUp(item)">
								{{ item }}
							</div>
						</div>


					</div>

					<div style="display: flex; margin-top: 10px; flex-direction: row-reverse;"
						v-if="message.type == 'user'">
						<div style="width: 36px; height: 36px;margin-right: 7px; "><img src="../images/usericon.png" />
						</div>
						<div
							style="max-width: 85%;background: linear-gradient(-30deg, #4993D8 0%, #43B5E0 100%); color: #FEFEFE; border-radius: 9px; padding: 7px;margin-right: 5px;display: flex;align-items: center;">
							{{ message.text }}</div>
					</div>
				</div>
			</div>
            <div style="display: flex;align-items: center;justify-content: center; margin-top: 10px;">
				<input v-model="inputMessage" placeholder="请输入您的问题..."
					style="width: 270px;height: 24px; background-color: #F8FCFF;border-radius: 3px;padding-left: 5px;"
					v-on:keyup.enter="sendMessage" />
				<button @click="sendMessage"
					style="width: 58px;height: 24px;background: linear-gradient(-30deg, #4993D8 0%, #43B5E0 100%);border-radius: 3px; border: none; display: flex;align-items: center;justify-content: center;font-size: 12px;color: #FFFFFF;margin-left: 16px;">发送</button>
			</div>
        </div>
        <div class="index_info_team">
            <div class="index_info_team_left_intro">
                <div class="index_info_team_left_intro_first" @click=toSzll() style="cursor: pointer;">
                    <div class="index_info_team_left_intro_first_text">团队/个人简介</div>
                    <div class="index_info_team_left_intro_first_img"><img src="../images/grjj.png"></div>
                </div>
                <div class="index_info_team_left_intro_two">
                    Team/Personal Profile
                </div>
                <div class="index_info_team_left_intro_three" style="overflow: hidden;">
                    <img style="height: 100%; width: 100%; object-fit: cover;"  src="../images/ren.png"/>
                </div>
            </div>
            <div class="index_info_team_right_detail">
                <div class="index_info_team_right_detail_more" @click=toSzll()>
                    查看更多>>
                </div>
   
                <div class="index_info_team_right_detail_tdjj">
                    <div class="index_info_team_right_detail_tdjj_icon"></div>
                    <div class="index_info_team_right_detail_tdjj_text">个人简介</div>
                </div>
                <div class="index_info_team_right_detail_tddetail" style=" -webkit-line-clamp: 6;">张鸿郭，男，1979年10月生，博士，广州大学环境科学与工程学院教授，博士生导师。主持参与国家自然科学基金、国家科技成果重点推广计划、国家自然科学基金广东省联合基金、广东省重点科技攻关项目、广东省科技攻关项目、广东省城市地质调查项目、广州市科技攻关项目、广州市教育局项目、华南理工大学高水平大学苗子项目和广州市新苗项日等多个科研项目。共在国内外刊物上发表论文60余篇;授权发明专利1项，实用新型专利3项，申请发明专利6项:获省部级科技奖3项。</div>
                             <div class="index_info_team_right_detail_tdjj" style="margin-top: 20px;">
                    <div class="index_info_team_right_detail_tdjj_icon"></div>
                    <div class="index_info_team_right_detail_tdjj_text">研究简介</div>
                </div>
                <div class="index_info_team_right_detail_tddetail">
                    2006年至今任教于广州大学环境科学与工程学院，在包括美国，澳大利亚，西班牙，希腊，瑞典在内的多个国家进行过研究访学和文化交流研空领城句托:环境生物技术，环境功能材料，周体废物外置与资源化，主持和参加5项国家白然科学基金咨助项目在内的30多项科研项目，发表学术论文60余篇，授权和申请国家专利20余项，入选珠江科技新星人才培养计划和广东省“十百千”工程人才培养计划。
                </div>
            </div>
        </div>
        <div class="index_info_keyan">
            <div class="index_info_keyan_left" @click="toKycgDetail(kycgList[0])">
                <div class="index_info_team_left_intro_first">
                    <div class="index_info_team_left_intro_first_text" style="width: auto;">科研与教学成果</div>
                    <div class="index_info_team_left_intro_first_img"><img src="../images/kycg.png"></div>
                    <div class="index_info_team_right_detail_more" style="position: relative;left: 180px;"
                        @click="toKycg()">
                        查看更多>>
                    </div>
                </div>
                <div class="index_info_team_left_intro_two">
                    Research and teaching achievements
                </div>
                <div class="index_info_keyan_left_three" style="overflow: hidden;">
                    <img :src="getUrl + kycgList[0].imgUrl" />
                </div>
                <div class="index_info_keyan_left_fourth">
                    <div
                        style="font-family: SourceHanSansCNVF, SourceHanSansCNVF;font-weight: 400;font-size: 18px;color: #FFFFFF;padding-left: 5px;">
                        {{ kycgList[0].title }}
                    </div>
                    <div
                        style="font-family: SourceHanSansCNVF, SourceHanSansCNVF;font-weight: 400;font-size: 13px;color: #FFFFFF; text-align: right; padding-right: 5px;">
                        {{ kycgList[0].awardTime }}</div>
                </div>

            </div>
            <div class="index_info_keyan_right" v-if="kycgListTwo.length>0">
                <div v-for="(item, index) in kycgListTwo" class="index_info_keyan_right_item_unactive"
                    :class="item.active == true ? 'index_info_keyan_right_item_active' : ''" @mouseover="item.active = true"
                    @mouseleave="item.active = false" @click="toKycgDetail(item)" >
                    <div class="index_info_keyan_right_item_unactive_left"
                        :class="item.active == true ? 'index_info_keyan_right_item_active_left' : ''">
                        <div class="index_info_keyan_right_item_unactive_left_text"
                            :class="item.active == true ? 'index_info_keyan_right_item_active_left_text' : ''">{{
                    returnMouth(item.awardTime) }}/{{ returnDay(item.awardTime) }}</div>
                        <div class="index_info_keyan_right_item_unactive_left_line"
                            :class="item.active == true ? 'index_info_keyan_right_item_active_left_line' : ''"></div>
                        <div class="index_info_keyan_right_item_unactive_left_text"
                            :class="item.active == true ? 'index_info_keyan_right_item_active_left_text' : ''"> {{
                    returnYear(item.awardTime) }}</div>
                    </div>
                    <div class="index_info_keyan_right_item_unactive_right"
                        :class="item.active == true ? 'index_info_keyan_right_item_active_right' : ''">
                        <div class="index_info_keyan_right_item_unactive_right_first"
                            :class="item.active == true ? 'index_info_keyan_right_item_active_right_first' : ''" style="display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{
                    item.title }}</div>
                        <div class="index_info_keyan_right_item_unactive_right_second"
                            :class="item.active == true ? 'index_info_keyan_right_item_active_right_second' : ''"> </div>
                        <div class="index_info_keyan_right_item_unactive_right_three"
                            :class="item.active == true ? 'index_info_keyan_right_item_active_right_three' : ''" style="display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{
                    item.remark }}</div>
                    </div>
                </div>

            </div>

        </div>
        <div class="index_info_coure">
            <div class="index_info_team_left_intro" style="height: 100px; cursor: pointer;" @click="toZxkc()" >
                <div class="index_info_team_left_intro_first">
                    <div class="index_info_team_left_intro_first_text">热门课程资源</div>
                    <div class="index_info_team_left_intro_first_img"><img src="../images/kcgl.png"></div>
                </div>
                <div class="index_info_team_left_intro_two">
                    Popular course resources
                </div>
            </div>
            <div class="index_info_coure_list">
                <div class="index_info_coure_list_item_unactive" v-for="(item, index) in courseList"
                    :class="item.active == true ? 'index_info_coure_list_item_active' : ''" @mouseover="item.active = true"
                    @mouseleave="item.active = false" @click="toZxkcDetail(item)" >
                    <div class="index_info_coure_list_item_active_img" style="overflow: hidden;"><img
                            :src="getUrl + item.imgUrl" /></div>
                    <div class="index_info_coure_list_item_active_tag">{{ item.type }}</div>
                    <div class="index_info_coure_list_item_unactive_title"
                        :class="item.active == true ? 'index_info_coure_list_item_active_title' : ''"style="display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{ item.title }}</div>
                </div>
            </div>
        </div>
        <div class="index_info_honor">
            <div class="index_info_team_left_intro" style="height: 100px;">
                <div class="index_info_team_left_intro_first">
                    <div class="index_info_team_left_intro_first_text">获得荣誉</div>
                    <div class="index_info_team_left_intro_first_img"><img src="../images/hdry.png"></div>
                </div>
                <div class="index_info_team_left_intro_two">
                    Received honors
                </div>

            </div>
            <div class="index_info_honor_list">
                <div class="index_info_honor_list_item">
                    <div class="index_info_honor_list_item_img"><img style="height: 100%; width: 100%; object-fit: cover;" src="../images/h1.png"></div>
                    <div class="index_info_honor_list_item_text">国家级一流本科课程</div>
                </div>
                <div class="index_info_honor_list_item">
                    <div class="index_info_honor_list_item_img"><img  style="height: 100%; width: 100%; object-fit: cover;"  src="../images/h2.png"></div>
                    <div class="index_info_honor_list_item_text">广东省环境保护科学技术一等奖</div>
                </div>
                <div class="index_info_honor_list_item">
                    <div class="index_info_honor_list_item_img"><img  style="height: 100%; width: 100%; object-fit: cover;"  src="../images/h3.png"></div>
                    <div class="index_info_honor_list_item_text">全国大学生冶金科技竞赛三等奖</div>
                </div>
            </div>

        </div>
        <div class="index_info_news">
            <div class="index_info_team_left_intro" style="height: 100px; cursor: pointer;" @click="toHzjl()">
                <div class="index_info_team_left_intro_first">
                    <div class="index_info_team_left_intro_first_text">新闻动态</div>
                    <div class="index_info_team_left_intro_first_img"><img src="../images/xwdt.png"></div>
                </div>
                <div class="index_info_team_left_intro_two">
                    news information
                </div>
            </div>
            <div class="index_info_news_content">
                <div class="index_info_news_content_left" @click="toHzjlDetail(newsList[0])">
                    <div class="index_info_news_content_left_toptext">
                        <div class="index_info_news_content_left_toptext_title">{{ newsList[0].title }}</div>
                        <div class="index_info_news_content_left_toptext_date">{{ newsList[0].happenTime }}</div>
                    </div>
                    <div class="index_info_news_content_left_detail">
                        <div class="index_info_news_content_left_detail_img" ><img style="height: 100%; width: 100%; object-fit: cover; "
                                :src="getUrl + newsList[0].imgUrl" />
                        </div>
                        <div class="index_info_news_content_left_detail_text" v-html="newsList[0].content">

                        </div>

                    </div>
                </div>
                <div class="index_info_news_content_right">
                    <div class="index_info_news_content_right_unactive_item" v-for="(item, index) in newsListTwo"
                        :class="item.active == true ? 'index_info_news_content_right_active_item' : ''"
                        @mouseover="item.active = true" @mouseleave="item.active = false" @click="toHzjlDetail(item)">
                        <div class="index_info_news_content_right_unactive_item_toptext"
                            :class="item.active == true ? 'index_info_news_content_right_active_item_toptext' : ''">
                            <div class="index_info_news_content_right_unactive_item_toptext_left"
                                :class="item.active == true ? 'index_info_news_content_right_active_item_toptext_left' : ''">
                                {{ item.title }}</div>
                            <div class="index_info_news_content_right_unactive_item_toptext_right"
                                :class="item.active == true ? 'index_info_news_content_right_active_item_toptext_right' : ''">
                                {{ item.happenTime }}</div>
                        </div>
                        <div class="index_info_news_content_right_unactive_item_bottomtext" v-html="item.content"
                            :class="item.active == true ? 'index_info_news_content_right_active_item_bottomtext' : ''">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { url } from '../services/url'
import {
    getKycgListNoType, getCourseListNoType, getHzjlListNoType
} from "../services/services";
export default {
    name: 'Index',
    data() {
        return {
            kycgList: [],
            kycgListTwo: [],
            courseList: [],
            newsList: [],
            newsListTwo: [],
            userId: localStorage.getItem('userId'),
            aiChatShow: false,
			messages: [],
			inputMessage: '',
			tempAnswer: '',
			index: 1,
			chatHistory: [],
			count: 1,
            getUrl: url,
        }
    },
    created() {
        getKycgListNoType(this.userId, 1, 4).then(res => {
            this.kycgList = res.rows
            this.kycgListTwo = res.rows.slice(1)
            console.log("1"+this.kycgList)

        })
        getCourseListNoType(this.userId, 1, 4).then(res => {
            this.courseList = res.rows
            console.log("2"+this.courseList)
        })
        getHzjlListNoType(this.userId, 1, 4).then(res => {
            this.newsList = res.rows
            this.newsListTwo = res.rows.slice(1)
            console.log("3"+this.newsList)

        })
        this.messages.push({
			text: '你好，我是环境科学与工程教研一体化平台AI助理，相关专业的问题都可以问我哦~',
			type: 'bot'
		});

    },
    methods: {
        toSzll() {
            localStorage.setItem('activeIndex', 4);
            this.$router.push({
                path: '/szll',
            });
        },
        toKycg() {
            localStorage.setItem('activeIndex', 5);
            this.activeIndex=5;
            this.$router.push({
                path: '/kycg',
            });
        },
        toKycgDetail(item) {
            console.log(item)
            this.$router.push({
                path: '/kycg',
                query: {
                    item: item
                }
            });
        },
        toZxkc(){
            this.$router.push({
                path: '/zxkc',

            });
        },
        toZxkcDetail(item){
            this.$router.push({
                path: '/zxkc',
                query: {
                    item: item
                }
            });
        },
        toHzjl(){
            this.$router.push({
                path: '/hzjl',

            });
        },
        toHzjlDetail(item){
            this.$router.push({
                path: '/hzjl',
                query: {
                    item: item
                }
            });
        },
        returnYear(date) {
			if(date!=null){
				return date.slice(0, 4);
			}
           
        },
        returnMouth(date) {
			if(date!=null){
				return date.slice(5, 7);
			}
            
        },
        returnDay(date) {
			if(date!=null){
				return date.slice(8, 10);
			}
            
        },
        getSpecialAnswer() {
			if (this.count == 1) {
				this.messages.push({
					text: '让我们一步步来探讨“颅内化脓性感染”这一医学主题。让我们开始这个过程<br>第一步：了解颅内化脓性感染的基本概念<br>颅内化脓性感染是指细菌、真菌或病毒引起的脑膜、脑实质、脑室系统或颅内血管的感染。这是一种严重的医疗急症，需要及时诊断和治疗。<br>问题思考：你能列举颅内化脓性感染可能涉及的结构吗？<br>（等你回答后，我会继续下一步的引导。）',
					type: 'bot',
					fllowups: []
				});
				this.$nextTick(() => {
					const chatContainer = this.$refs.chatContainer;
					chatContainer.scrollTop = chatContainer.scrollHeight;
				});
				this.count++
				return
			}
			if (this.count == 2) {
				this.messages.push({
					text: '很好，你提到了脑膜，这是颅内化脓性感染常见的一个受累结构。除了脑膜，颅内化脓性感染还可能涉及以下结构：<br>脑实质：感染可以直接侵犯大脑或小脑的实质。<br>脑室系统：包括侧脑室、第三脑室和第四脑室，感染可能导致脑室炎。<br>颅内血管：感染可能导致血管炎，甚至引发血栓形成。<br>第二步：认识颅内化脓性感染的类型<br>颅内化脓性感染主要包括以下几种类型：脑膜炎：感染累及脑膜。脑炎：感染累及脑实质。<br>脑脓肿：局限性脓肿形成于脑实质内。硬脑膜下积脓：感染发生在硬脑膜与大脑表面之间。<br>问题思考：每种类型的感染在病理上有何不同？<br>（等你回答后，我会继续解释每种类型的特征。）',
					type: 'bot',
					fllowups: []
				});
				this.$nextTick(() => {
					const chatContainer = this.$refs.chatContainer;
					chatContainer.scrollTop = chatContainer.scrollHeight;
				});
				this.count++
				return
			}
			if (this.count == 3) {
				this.messages.push({
					text: '正确，颅内化脓性感染可以根据病原体的不同分为几类：<br>细菌性感染：这是最常见的类型，病原体可以是各种细菌，如脑膜炎球菌、肺炎球菌、金黄色葡萄球菌等。<br>真菌性感染：相对较少见，但仍然重要，病原体如隐球菌、念珠菌等。<br>病毒性感染：虽然病毒通常不引起化脓性感染，但某些病毒，如单纯疱疹病毒，也可以引起脑炎，这可能导致类似化脓性感染的炎症反应。</br>病毒性感染：虽然病毒通常不引起化脓性感染，但某些病毒，如单纯疱疹病毒，也可以引起脑炎，这可能导致类似化脓性感染的炎症反应。</br>问题思考：不同类型的颅内化脓性感染在治疗上有哪些关键差异？</br>',
					type: 'bot',
					fllowups: []
				});
				this.$nextTick(() => {
					const chatContainer = this.$refs.chatContainer;
					chatContainer.scrollTop = chatContainer.scrollHeight;
				});
				this.count++
				return
			}

		},
		async getAnswer(question) {
			let param = {
				"conversation_id": "123",
				"bot_id": "7394354155844386854",
				"user": "29032201862555",
				"query": question,
				"stream": true,
				"chat_history": this.chatHistory
			}
			try {
				const response = await fetch('https://api.coze.cn/open_api/v2/chat', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer pat_p5kRWOqZNZyhUFqYMnINMpwtNpuKANclloPq6faKiMlGr5rixmE7aPu93LjfzNWy'
					},
					body: JSON.stringify(param)
				});
				if (!response.ok) {
					throw new Error('网络请求失败: ' + response.status);
				}

				const reader = response.body.getReader();
				let partialMessage = '';
				this.messages.push({
					text: '',
					type: 'bot',
					fllowups: []
				});
				while (true) {
					const { done, value } = await reader.read();
					if (done) {
						break;
					}
					const chunk = new TextDecoder().decode(value);
					partialMessage += chunk;
					// 处理完整的消息，可以根据实际需要进行处理
					const messages = partialMessage.split('data:{');
					messages.forEach((item, index) => {
						if (item.trim() !== '') {
							const item1 = '{"data":{' + item + '}';
							if (this.isValidJSON(item1)) {
								const parsedData = JSON.parse(item1);
								if (parsedData.data.message.type == 'answer') {
									this.messages[this.index].text = this.messages[this.index].text + parsedData.data.message.content
									this.$nextTick(() => {
										const chatContainer = this.$refs.chatContainer;
										chatContainer.scrollTop = chatContainer.scrollHeight;
									});
								}
								if (parsedData.data.message.type == 'follow_up') {
									this.messages[this.index].fllowups.push(parsedData.data.message.content)
									this.$nextTick(() => {
										const chatContainer = this.$refs.chatContainer;
										chatContainer.scrollTop = chatContainer.scrollHeight;
									});
								}
							}
						}
					});
					// 清空部分消息
					partialMessage = '';
				}
				this.chatHistory.push({
					"role": "user",
					"type": "query",
					"content": this.messages[this.index].text,
					"content_type": "text"
				})
				console.log(this.messages[this.index].text)
			} catch (error) {
				console.error('错误信息:', error.message);
				this.isCanSpeak = true;
				// 处理错误情况
			}
		},
		isValidJSON(str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}
			return true;
		},		sendMessageByFllowUp(item) {
			this.inputMessage = item
			this.sendMessage()

		},
		sendMessage() {
			if (this.inputMessage.trim() === '') return;

			if (this.index == 1) {
				this.index = this.index + 1
			}
			else {
				this.index = this.index + 2
			}

			this.messages.push({
				text: this.inputMessage.trim(),
				type: 'user',
				fllowups: []
			});
			this.chatHistory.push({
				"role": "user",
				"type": "query",
				"content": this.inputMessage.trim(),
				"content_type": "text"
			})
			this.$nextTick(() => {
				const chatContainer = this.$refs.chatContainer;
				chatContainer.scrollTop = chatContainer.scrollHeight;
			});
			 this.getAnswer(this.inputMessage.trim());
			// this.getSpecialAnswer()


			this.inputMessage = '';
			console.log(this.messages)
		},

    },
}
</script>
<style>
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 100px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
.chat-dialog {
	background-image: url('../images/aichatbg.png');
	background-size: cover;
	position: fixed;
	left: 57%;
	top: 240px;
	z-index: 10;

}


.chat-content {
	height: 260px;
	overflow-y: auto;
	margin-right: 10px;
}

/* 自定义滚动条的宽度 */
.chat-content::-webkit-scrollbar {
	width: 4px;
	background: linear-gradient(0deg, #4993D8 0%, #43B6E0 100%);
	border-radius: 1px;
}

/* 滚动条轨道 */
.chat-content::-webkit-scrollbar-track {
	background: #F1F6F9;
}

/* 滚动条滑块 */
.chat-content::-webkit-scrollbar-thumb {
	background: linear-gradient(0deg, #4993D8 0%, #43B6E0 100%);
	border-radius: 6px;
}
</style>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>
